// extracted by mini-css-extract-plugin
export default {"key-visual":"KeyVisual_key-visual__16D7o","caption":"KeyVisual_caption__j2yNf"};